import { FraudElementContributors } from "../../../api/fraudElements";

export interface FraudElementObservationConfig {
  title: string;
  placeholder: string;
}

export const FRAUD_ELEMENT_OBSERVATION_CONFIG: Record<
  FraudElementContributors,
  FraudElementObservationConfig
> = {
  [FraudElementContributors.BORROWER_RESPONSE]: {
    title: "Borrower Reply",
    placeholder: "Enter borrower reply...",
  },

  [FraudElementContributors.FRAUD_CONTROL_UNIT]: {
    title: "FCU Observations",
    placeholder: "Enter FCU observations...",
  },

  [FraudElementContributors.BRANCH_OFFICE]: {
    title: "Branch Observations",
    placeholder: "Enter branch observations...",
  },

  [FraudElementContributors.ZONAL_OFFICE]: {
    title: "Zonal Observations",
    placeholder: "Enter zonal observations...",
  },

  [FraudElementContributors.REGIONAL_OFFICE]: {
    title: "Regional Observations",
    placeholder: "Enter regional observations...",
  },

  [FraudElementContributors.FRAUD_RISK_MANAGEMENT_DEPT]: {
    title: "FRMD Observations",
    placeholder: "Enter FRMD observations...",
  },

  [FraudElementContributors.FIELD_GENERAL_MANAGER]: {
    title: "FGM Observations",
    placeholder: "Enter FGM observations...",
  },

  [FraudElementContributors.GENERAL_MANAGER]: {
    title: "GM Observations",
    placeholder: "Enter GM observations...",
  },

  [FraudElementContributors.EXECUTIVE_DIRECTOR]: {
    title: "ED Observations",
    placeholder: "Enter ED observations...",
  },

  [FraudElementContributors.MANAGING_DIRECTOR]: {
    title: "MD Observations",
    placeholder: "Enter MD observations...",
  },
};